import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Check, X, Calendar, Trash2 } from 'lucide-react';
import { getLeaveTypeLabel, LeaveStatusBadge } from '../../lib/leaves';
import { displayDate } from '../../lib/dates';

export const LeaveCardList = ({ leaves, onStatusUpdate, onDelete }) => (
  <div className="md:hidden space-y-3" data-testid="leaves-mobile-list">
    {leaves.length === 0 ? (
      <Card className="bg-white border border-[#D1D1CD] rounded-lg">
        <CardContent className="p-6 text-center text-[#5C5C5C]">
          No leave requests found
        </CardContent>
      </Card>
    ) : (
      leaves.map((leave) => (
        <Card
          key={leave.id}
          data-testid={`leave-card-${leave.id}`}
          className="bg-white border border-[#D1D1CD] rounded-lg shadow-sm"
        >
          <CardContent className="p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-[#1C1C1E] truncate">{leave.worker_name}</p>
                <Badge variant="outline" className="border-[#D1D1CD] mt-1.5">
                  {getLeaveTypeLabel(leave.leave_type)}
                </Badge>
              </div>
              <LeaveStatusBadge status={leave.status} />
            </div>
            <div className="mt-3 flex items-center gap-1.5 text-sm text-[#5C5C5C]">
              <Calendar className="w-4 h-4" />
              <span>{displayDate(leave.start_date)} to {displayDate(leave.end_date)}</span>
            </div>
            {leave.reason && (
              <p className="mt-2 text-sm text-[#5C5C5C] line-clamp-2">{leave.reason}</p>
            )}
            <div className="mt-3 pt-3 border-t border-[#D1D1CD]/60 flex justify-end gap-2">
              {leave.status === 'pending' && (
                <>
                  <Button
                    variant="ghost"
                    size="sm"
                    data-testid={`approve-leave-mobile-${leave.id}`}
                    onClick={() => onStatusUpdate(leave.id, 'approved')}
                    className="h-9 text-[#2E4632] hover:bg-[#2E4632]/10"
                  >
                    <Check className="w-4 h-4 mr-1.5" /> Approve
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    data-testid={`reject-leave-mobile-${leave.id}`}
                    onClick={() => onStatusUpdate(leave.id, 'rejected')}
                    className="h-9 text-[#D97706] hover:bg-[#D97706]/10"
                  >
                    <X className="w-4 h-4 mr-1.5" /> Reject
                  </Button>
                </>
              )}
              <Button
                variant="ghost"
                size="sm"
                data-testid={`delete-leave-mobile-${leave.id}`}
                onClick={() => onDelete(leave.id)}
                className="h-9 text-[#BC4749] hover:bg-[#BC4749]/10"
              >
                <Trash2 className="w-4 h-4 mr-1.5" /> Delete
              </Button>
            </div>
          </CardContent>
        </Card>
      ))
    )}
  </div>
);
